// Catalogue extensible des origines d'acquéreurs (CRM OFF MARKETTE).
// Ajouter une origine = une entrée ici (miroir du backend ai_assist.ACQUEREUR_ORIGINS).
export const ACQ_ORIGINS = {
  fichier_historique: { label: "Mon fichier historique", emoji: "🏆", color: "#C19A6B" },
  prospection_ia: { label: "Prospection IA", emoji: "🤖", color: "#8B5CF6" },
  reseau: { label: "Mon réseau", emoji: "👥", color: "#3B82F6" },
  invitation: { label: "Invitation OFF MARKETTE", emoji: "📧", color: "#0EA5E9" },
  spontane: { label: "Inscription spontanée", emoji: "🌐", color: "#10B981" },
  partenaire: { label: "Partenaire", emoji: "🏢", color: "#F59E0B" },
  qr_evenement: { label: "QR / Salon / Événement", emoji: "📱", color: "#EC4899" },
  parrainage: { label: "Parrainage", emoji: "🔗", color: "#14B8A6" },
  campagne: { label: "Campagne Marketing", emoji: "🎯", color: "#EF4444" },
  import_vocal: { label: "Import vocal IA", emoji: "🎙️", color: "#A855F7" },
  autre: { label: "Autre", emoji: "•", color: "#71717A" },
};

export const originMeta = (key) => ACQ_ORIGINS[key] || ACQ_ORIGINS.autre;

export function OriginBadge({ origin, className = "" }) {
  const m = originMeta(origin || "spontane");
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-medium uppercase tracking-wider px-2 py-1 rounded-full border ${className}`}
      style={{ color: m.color, borderColor: m.color + "66", backgroundColor: m.color + "1a" }}
      data-testid={`acq-origin-badge-${origin || "spontane"}`}
      title={`Origine : ${m.label}`}
    >
      <span>{m.emoji}</span> {m.label}
    </span>
  );
}
